import React from "react";

/**
 * מעטפת תוכן בסגנון אשף הטיסות (רקע גרדיאנט + רוחב max כמו review).
 * דורש טעינת fwUiKit.css באב.
 */
export default function FWPageLayout({ children, gradient = true, className = "" }) {
  return (
    <div
      className={`fw-ui-page-shell${gradient ? " fw-ui-page-shell--gradient" : ""}${
        className ? ` ${className}` : ""
      }`.trim()}
    >
      <div className="fw-ui-page-body">{children}</div>
    </div>
  );
}
